












import rqcode from "./rqcode.vue";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { TradeMode } from "@/model/Base";
import billService from "@/service/billService";

@Component({
  name: "rqcode",
  filters: {
    paymentIcon(typeCode: string) {
      return `/static/img/${typeCode}.png`;
    },
  },
})
export default class extends Vue {
  rqcode = "";
  @Prop()
  value: any;
  @Prop()
  serviceType: any;
  mounted() {
    if (this.value && this.value != "") {
      this.rendcode();
    }
  }
  rendcode() {
    var options = this.value;
    if (typeof options === "string") {
      options = {
        text: options,
      };
    }
    let win = window as any;
    let $ = win.zepto;
    let QRErrorCorrectLevel = win.QRErrorCorrectLevel;
    let QRCode = win.QRCode;
    options = $.extend(
      {},
      {
        render: "table",
        width: 256,
        height: 256,
        typeNumber: -1,
        correctLevel: QRErrorCorrectLevel.H,
        background: "#ffffff",
        foreground: "#000000",
      },
      options
    );
    var qrcode = new QRCode(options.typeNumber, options.correctLevel);
    qrcode.addData(options.text);
    qrcode.make();

    // create table element
    var $table = $("<table></table>")
      .css("width", options.width + "px")
      .css("height", options.height + "px")
      .css("border", "0px")
      .css("border-collapse", "collapse")
      .css("background-color", options.background)
      .css("margin-left", "auto")
      .css("margin-right", "auto");

    // compute tileS percentage
    var tileW = options.width / qrcode.getModuleCount();
    var tileH = options.height / qrcode.getModuleCount();

    // draw in the table
    for (var row = 0; row < qrcode.getModuleCount(); row++) {
      var $row = $("<tr></tr>")
        .css("height", tileH + "px")
        .appendTo($table);

      for (var col = 0; col < qrcode.getModuleCount(); col++) {
        $("<td></td>")
          .css("width", tileW + "px")
          .css("background-color", qrcode.isDark(row, col) ? options.foreground : options.background)
          .appendTo($row);
      }
    }
    this.rqcode = $table[0].outerHTML;
  }
  showService() {
    // var service = _.find(this.ServiceTypes, o => o.CategoryID == this.serviceType);
    // if (service) {
    //   return service.CategoryTitle.replace("服务", "订单");
    // }
    return "超额自付订单";
  }
  @Watch("value")
  valueChange() {
    this.rendcode();
  }
}
